import { LocalizedString } from '@angular/compiler';
import { Component } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  catchError,
  finalize,
  map,
  Observable,
  of,
  switchMap,
  tap,
  timeout,
} from 'rxjs';
import {
  CandidatureRequest,
  PrerequisiteDTO,
} from 'src/app/model/CandidatureRequest.model';
import { Countries } from 'src/app/model/countries';
import { Days } from 'src/app/model/days';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { Mounths } from 'src/app/model/mounths';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { Years } from 'src/app/model/years';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { confirmEqualValidator } from 'src/app/modules/shared/validators/confirm-equal';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { MentoratService } from '../../services/mentorat.service';
import { CertificatMentorats } from 'src/app/model/certificatMentorats';

@Component({
  selector: 'app-form-candidature-mentorat',
  templateUrl: './form-candidature-mentorat.component.html',
  styleUrls: ['./form-candidature-mentorat.component.css'],
})
export class FormCandidatureMentoratComponent {
  phoneCode!: any[];
  phoneCodeWhatsapp!: any[];

  soumissionForm!: FormGroup;
  emailForm!: FormGroup;

  days!: any;
  months!: any;
  years!: any;
  diplomes!: any;
  students!: any;
  otherStatus!: any;
  zones!: any;
  regions!: any;
  pays!: any;
  user!: any;
  series: any[] = [];
  files: File[] = [];
  maxSize: number = 2097152;
  fileSize!: number;
  badSize: boolean = false;

  disciplines: any[] = [];

  skillLevel!: any;
  emailMatched: boolean = false;
  typedEmail: string = '';
  showSpecificRegionDiv: boolean = false;
  noSession: boolean = false;
  session: boolean = false;
  showDisciplineDivDoctorat: boolean = false;
  cohorteAppel: any = null;
  isRequired: boolean = false;

  showWhatsAppNumberFields: boolean = false;

  controlsList: string[] = [
    'firstname',
    'lastname',
    'selectedDate',
    'selectedSexe',
    'phoneNumber',
    'phoneCode',
    'isWhatsApp',
    'emailGroup.email',
    'emailGroup.confirmEmail',
    'selectedCountry',
    'selectedSituation',
    'selectedRegion',
    'selectedZone',
    'professionnalSituation',
  ];

  showEmailErrors$!: Observable<boolean>;

  showSpinner = false;
  listCertificat: CertificatMentorats[] = [];
  cohorteMentorat!: string;
  idApplicationMentorat!: number;
  certificateIds: number[] = [];
  statut_actuel = [
    'Salarié',
    'Consultant / free lance',
    'Entrepreneur',
    'Autre',
  ];
  // booleanresponce = ['Oui', 'Non'];
  isSucces: boolean = false;
  isLoading: boolean = false;
  showExperienceEnLigne = false;
  showExperienceMentorat = false;

  constructor(
    private formBuilder: FormBuilder,
    private backendapiService: AuthService,
    private router: Router,
    private serviceMentorat: MentoratService,
    private actived: ActivatedRoute,
    private spinner: SpinnerServiceService,
  ) {
    this.emailForm = this.formBuilder.group(
      {
        email: [null, [Validators.required, Validators.email]],
        confirmEmail: [null, [Validators.required, Validators.email]],
      },
      {
        validators: [confirmEqualValidator('email', 'confirmEmail')],
      },
    );
    this.soumissionForm = this.formBuilder.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      selectedDate: [null, Validators.required],
      selectedSexe: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      phoneCode: ['221', Validators.required],
      isWhatsApp: [null, Validators.required],
      whatsAppNumber: [null],
      phoneCodeForWhatsApp: ['221'],
      emailGroup: this.emailForm,
      selectedDiplome: [null, Validators.required],
      professionnalSituation: this.formBuilder.array([], Validators.required),
      selectedRegion: [null, Validators.required],
      listCertificats: this.formBuilder.array([], Validators.required),
      lieu_naissance: [null, Validators.required],
      ville_residence: [null, Validators.required],
      pays_residence: [null, Validators.required],
      onlineAcademyExprience: [null, Validators.required],
      experience_mentorat: [null, Validators.required],
      desc_experience: [null],
      desc_phase_mentorat: [null],
      plus_detail: [null],
      fileSource: new FormControl([], [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.spinner.hideSpinner();
    this.cohorteAppel = this.actived.snapshot.paramMap.get('cohorte') || '';
    //application
    this.getCurrentApplication();

    this.checkEmail();
    this.getCountry();
    // this.initPaysResidance()

    // this.controlsList.forEach((value) => {
    //   //console.log('element', value);
    // });

    this.isEmailMatched();

    this.zones = LOCALISATIONS.Zones;
    this.regions = LOCALISATIONS.Regions;
    this.pays = LOCALISATIONS.Pays;

    this.diplomes = ProfilDetails.DiplomeForApplications;
    this.students = ProfilDetails.Student;
    this.otherStatus = ProfilDetails.OtherStatus;

    // this.days = Days.List;
    // this.months = Mounths.List;
    // this.years = Years.List;
    this.soumissionForm
      .get('onlineAcademyExprience')
      ?.valueChanges.subscribe((val) => {
        const descControl = this.soumissionForm.get('desc_experience');
        if (val === true) {
          descControl?.setValidators([Validators.required]);
        } else {
          descControl?.clearValidators();
          descControl?.setValue(null);
        }
        descControl?.updateValueAndValidity();
      });

    this.soumissionForm
      .get('experience_mentorat')
      ?.valueChanges.subscribe((val) => {
        const descControl = this.soumissionForm.get('desc_phase_mentorat');
        if (val === true) {
          descControl?.setValidators([Validators.required]);
        } else {
          descControl?.clearValidators();
          descControl?.setValue(null);
        }
        descControl?.updateValueAndValidity();
      });
    this.soumissionForm.get('isWhatsApp')?.valueChanges.subscribe((val) => {
      const descControl = this.soumissionForm.get('whatsAppNumber');
      if (val === 'NON') {
        descControl?.setValidators([Validators.required]);
      } else {
        descControl?.clearValidators();
        descControl?.setValue(null);
      }
      descControl?.updateValueAndValidity();
    });
  }

  //get current application
  getCurrentApplication() {
    this.serviceMentorat
      .getCurrentApplicationMentorat(this.cohorteAppel)
      .subscribe({
        next: (data) => {
          if (data) {
            this.session = true;
            this.noSession = false;
            console.log('Application mentor :', data);
            this.listCertificat = data.certificatesMentorats;
            this.idApplicationMentorat = data.id;
            this.cohorteMentorat = data.cohorteMentorat;
            console.log('listCertificat :', this.listCertificat);
            console.log('id application :', this.idApplicationMentorat);
            console.log('cohorte mentorat :', this.cohorteMentorat);
          } else {
            this.noSession = true;
            this.session = false;
          }
        },
        error: (err) => {
          console.error('Erreur API :', err);
        },
      });
  }

  //recup le form array
  get listCertificatsFormArray(): FormArray {
    return this.soumissionForm.get('listCertificats') as FormArray;
  }

  onCertificatChange(e: any) {
    const formArray: FormArray = this.listCertificatsFormArray;

    if (e.target.checked) {
      formArray.push(this.formBuilder.control(+e.target.value)); // ajouter l'id selectionnei
    } else {
      const index = formArray.controls.findIndex(
        (x) => x.value === +e.target.value,
      );
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  initPhoneNumber() {
    this.soumissionForm
      .get('isWhatsApp')
      ?.valueChanges.subscribe((isWhatsApp) => {
        if (isWhatsApp === 'NON') {
          this.showWhatsAppNumberFields = true;
          this.soumissionForm
            .get('whatsAppNumber')
            ?.addValidators(Validators.required);
          this.soumissionForm
            .get('phoneCodeForWhatsApp')
            ?.addValidators(Validators.required);
        } else {
          this.showWhatsAppNumberFields = false;
          this.soumissionForm.get('whatsAppNumber')?.clearValidators();
          this.soumissionForm.get('phoneCodeForWhatsApp')?.clearValidators();
        }
      });
  }

  checkEmail() {
    this.showEmailErrors$ = this.emailForm.statusChanges.pipe(
      map(
        (status) =>
          status === 'INVALID' &&
          this.emailForm.get('email')?.value &&
          this.emailForm.get('confirmEmail')?.value,
      ),
    );
  }

  getCountry() {
    this.backendapiService.getCountries().subscribe((data) => {
      // //console.log(data);

      this.phoneCode = data.sort((c, d) => c.phoneCode - d.phoneCode);
      //console.log(this.phoneCode);

      this.phoneCodeWhatsapp = this.phoneCode;
    });
  }

  initPaysResidance() {
    this.soumissionForm
      .get('selectedCountry')
      ?.valueChanges.subscribe((values) => {
        if (values === 'Autre') {
          this.soumissionForm.addControl(
            'otherCountry',
            this.formBuilder.control(null, Validators.required),
          );
          this.controlsList.push('otherCountry');
        } else {
          this.soumissionForm.removeControl('otherCountry');
          this.controlsList = this.controlsList.filter(
            (e) => e !== 'otherCountry',
          );
        }
      });
  }

  markInvalidField(controlName: string) {
    const control = this.soumissionForm.get(controlName);

    if (control && control.invalid) {
      control.markAsTouched();
    }
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);

    return control && control.invalid && control.touched;
  }

  isFieldInvalidForMails(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);

    return control && control.errors?.['required'] && control.touched;
  }

  isMailFieldInvalid(control: string): boolean | null {
    return (
      this.emailForm.get(control)?.errors?.['email'] &&
      this.emailForm.get(control)?.touched
    );
  }

  Age(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Si le mois courant est avant le mois de naissance ou si c'est le même mois mais que le jour courant est avant le jour de naissance, décrémente l'âge
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  isEmailMatched() {
    this.soumissionForm
      .get('email')
      ?.valueChanges.pipe(
        tap((email) => {
          if (email != null && email != undefined) {
            //console.log('mail check: ', email != null && email != undefined);

            if (this.soumissionForm.get('confirmEmail')?.value === email) {
              this.emailMatched = true;
            } else {
              this.emailMatched = false;
            }
          }
        }),
      )
      .subscribe();
  }

  get professionnalSituation(): FormArray {
    return this.soumissionForm.get('professionnalSituation') as FormArray;
  }

  // l'ajout/retrait des cases selectionnei
  onCheckboxChange(event: any, statut: string) {
    const formArray: FormArray = this.soumissionForm.get(
      'professionnalSituation',
    ) as FormArray;

    if (event.target.checked) {
      formArray.push(this.formBuilder.control(statut)); // +
    } else {
      const index = formArray.controls.findIndex((x) => x.value === statut);
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  onFileChange(event: any) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const newFile: File[] = Array.from(input.files);

    // fichiers déjà sélectionnés
    const existingFiles: File[] =
      this.soumissionForm.get('fileSource')?.value || [];

    const mergedFile = [...existingFiles, ...newFile];

    mergedFile.forEach((file) => {
      this.fileSize = file.size;
      if (this.fileSize > this.maxSize) {
        this.soumissionForm.get('fileSource')?.markAsTouched;
        this.badSize = true;
      }
    });

    this.soumissionForm.patchValue({
      fileSource: mergedFile,
    });
    console.log('Fichiers sélectionnés :', mergedFile);
  }

  setValidators(
    controlToAdd: string,
    controlToRemove: string,
    controToRemove2: string,
  ) {
    this.soumissionForm.get(controlToAdd)?.addValidators(Validators.required);
    this.soumissionForm
      .get(controlToRemove)
      ?.removeValidators(Validators.required);
    this.soumissionForm
      .get(controToRemove2)
      ?.removeValidators(Validators.required);

    this.soumissionForm.get(controlToRemove)?.setValue(null);
    this.soumissionForm.get(controToRemove2)?.setValue(null);
  }

  removeFile(index: number) {
    const files = [...this.soumissionForm.get('fileSource')?.value];
    files.splice(index, 1);

    this.soumissionForm.patchValue({
      fileSource: files,
    });
  }

  onSubmit() {
    console.log(
      'Navigation vers : ',
      `mentorat/candidature/${this.cohorteAppel}/reussie/FODE`,
    );
    console.log('this.soumissionForm.value; ', this.soumissionForm.value);
    if (this.soumissionForm.valid) {
      this.isRequired = true;
      console.log('this.soumissionForm.value; ', this.soumissionForm.value);
      this.isLoading = true;

      const formValue = this.soumissionForm.value;
      const formData = new FormData();

      console.log(
        'Certificats sélectionnés (ids) :',
        this.soumissionForm.value.listCertificats,
      );
      this.certificateIds = this.soumissionForm.value.listCertificats;

      console.log('ids certificat : ', this.certificateIds);

      formData.append(
        'idApplication',
        JSON.stringify(this.idApplicationMentorat),
      );
      // formData.append('listCertificat',JSON.stringify(this.certificateIds));
      this.certificateIds.forEach((id: number) => {
        formData.append('listCertificat', id.toString());
      });
      // fichiers (MultipartFile[])
      this.files = this.soumissionForm.value.fileSource;
      this.files.forEach((file: File) => {
        formData.append('file', file);
      });

      console.log(
        'formValue.professionnalSituation : ',
        formValue.professionnalSituation,
      );

      console.log('file :', this.files);

      const requestBody = {
        firstname: formValue.firstname,
        lastname: formValue.lastname,
        dateBirth: formValue.selectedDate,
        gender: formValue.selectedSexe,
        email: formValue.emailGroup.email,
        phoneNumber: formValue.phoneNumber,
        isWhatsApp: formValue.isWhatsApp,
        whatsAppNumber: formValue.whatsAppNumber,
        nationality: formValue.pays_residence,
        region: formValue.selectedRegion,
        city: formValue.ville_residence,
        currentStatus: formValue.professionnalSituation,
        highDiplome: formValue.selectedDiplome,
        onlineAcademyExprience: formValue.onlineAcademyExprience,
        mentoratsExprience: formValue.experience_mentorat,
        descOnlineAcademyExprience: formValue.desc_experience,
        descMentoratsExprience: formValue.desc_phase_mentorat,
        additionalInformation: formValue.plus_detail,
        cohorte: this.cohorteMentorat,
      };

      formData.append('request', JSON.stringify(requestBody));

      console.log('idApplication (FormData) :', formData.get('idApplication'));
      console.log(
        'listCertificat (FormData) :',
        formData.get('listCertificat'),
      );
      console.log('request (FormData) :', formData.get('request'));
      console.log('files (FormData) :', formData.getAll('file'));
      this.serviceMentorat
        .addCandidatureMentorat(formData)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
        )
        .subscribe({
          next: (response) => {
            console.log('response sumbit 1:', response);
            this.isSucces = true;
            this.router.navigateByUrl(
              `mentorat/candidature/${this.cohorteAppel}/reussie/FODE`,
            );
          },
          error: (error) => {
            console.error('Erreur :', error);
          },
        });
    } else {
      this.isRequired = false;
      console.log('No valid');
      this.soumissionForm.markAllAsTouched();
    }
  }
}
